const link = "_link_1v5rz_8";
const styles = {
  link
};
export {
  styles as default,
  link
};
//# sourceMappingURL=Link.module.css.js.map
